import React, { useState } from "react";
import { Paper, Grid } from "@material-ui/core";
import {
  InputOptionMaster,
  InputTextMaster,
  MasterButton,
  InputCheckboxMaster,
  InputTextArea,
} from "App/Component/ui";

import { STYLE_JENIS_LAYANAN } from "App/Component/layout/MasterData/JenisLayanan/ui";
import {
  RESET_STATE_TEMPLATE,
  urlCreate,
  urlGetUnit,
  urlUpdate,
} from "./helpers";
import {
  TYPE_INSTANCE4,
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance3,
} from "App/constants";
import { useSelectOption } from "App/hooks";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import { TabMaster } from ".";

export default function FormTemplate({
  formData,
  setFormData,
  templateID,
  formReset,
  setNewData,
  setTemplateID,
}) {
  const classes = STYLE_JENIS_LAYANAN();
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  const unit = useSelectOption(true, urlGetUnit, TYPE_INSTANCE4, "id", "name");

  const add = async () => {
    const data = {
      nama: formData.nama,
      barang: formData.barang,
      jasa: formData.jasa,
      fasilitas: formData.fasilitas,
      rikjang: formData.rikjang,
      id_unit: formData.unit_id,
      status: formData.status,
      remark: formData.remark,
    };

    return instance3.post(urlCreate, data);
  };

  const update = async () => {
    const data = {
      id_template: templateID,
      nama: formData.nama,
      id_unit: formData.unit_id,
      status: formData.status,
      remark: formData.remark,
    };

    return instance3.post(urlUpdate, data);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (isNull(formData.nama) && isNull(formData.unit_id)) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Nama atau Unit tidak boleh kosong");
    } else {
      try {
        if (isNull(templateID)) {
          const res = await add();
          if (res.data.status === 200) {
            defaultToastSuccess("Berhasil menambah template");
            setFormData({
              ...RESET_STATE_TEMPLATE,
              barang: [],
              jasa: [],
              fasilitas: [],
              rikjang: [],
            });
            setTemplateID("");
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
            await setNewData();
          } else {
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
            defaultToastError(res.data.message);
          }
        } else {
          const res = await update();
          if (res.data.status === 200) {
            defaultToastSuccess("Berhasil mengubah template");
            setFormData({
              ...RESET_STATE_TEMPLATE,
              barang: [],
              jasa: [],
              fasilitas: [],
              rikjang: [],
            });
            setTemplateID("");
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
            await setNewData();
          } else {
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
            defaultToastError(res.data.message);
          }
        }
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(error?.response?.data?.message);
      }
    }
  };

  return (
    <Paper className={classes.paper}>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <Grid item sm={3}>
            <InputTextMaster
              name='id'
              label='ID'
              id='id'
              placeholder='-'
              readOnly={true}
              disabled={true}
              value={templateID}
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name='nama'
              label='NAMA'
              id='nama'
              autoFocus={true}
              value={formData.nama}
              onChange={handleChange("nama")}
              placeholder='Nama Template'
            />
          </Grid>

          <Grid item sm={3}>
            <InputOptionMaster
              name='unit_id'
              label='UNIT'
              id='unit_id'
              withSearch={true}
              disabled={isNull(templateID) ? false : true}
              data={unit}
              value={formData.unit_id}
              labelValue={formData.unit_name}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormData({
                    ...formData,
                    unit_id: null,
                    unit_name: "Pilih Unit",
                  });
                } else {
                  setFormData({
                    ...formData,
                    unit_id: e.value,
                    unit_name: e.label,
                  });
                }
              }}
            />
          </Grid>

          <Grid item sm={3}>
            <div className='pt-1'>
              <InputCheckboxMaster
                checked={formData.status}
                name='status'
                id='status'
                label='Aktif'
                style={{
                  height: "20px",
                  width: "20px",
                }}
                onChange={() =>
                  setFormData({ ...formData, status: !formData.status })
                }
              />
            </div>
          </Grid>

          <Grid item sm={12}>
            <InputTextArea
              label={"Catatan"}
              placeholder={"Catatan"}
              name='remark'
              value={formData.remark}
              onChange={handleChange("remark")}
              id='remark'
              rows={"3"}
            />
          </Grid>
        </Grid>

        <div className='mt-2'>
          <TabMaster
            formData={formData}
            setFormData={setFormData}
            templateID={templateID}
          />
        </div>

        <div className='mt-2'>
          <hr style={{ margin: "1rem 0", opacity: "0.3" }} />
          <Grid
            container
            direction='row'
            justifyContent='space-between'
            spacing={2}
            alignItems='center'>
            <MasterButton
              outline={true}
              type={"button"}
              color='danger'
              name='Reset'
              size='md'
              onClick={formReset}
            />

            <div>
              <MasterButton
                outline={false}
                type={"submit"}
                color={disabled.color}
                name={disabled.label}
                disabled={disabled.state}
                size='md'
              />
            </div>
          </Grid>
        </div>
      </form>
    </Paper>
  );
}
